<template>
   	<div id="emailTemplateBuilder">
        <div class="card">
            <div class="card-header d-flex">
                
                <div class="col-2 col-sm-3 order-1 order-sm-0">
            
                </div>

                <div class="col-12 col-sm-6 order-0 order-sm-1">
                  <h4 class="pt-2 mb-0 pb-1 text-center"><span class="popup-name" @click="editName">Email Template: {{ templateName }}</span></h4>
                </div>

                <div class="col-10 col-sm-3 order-2 order-sm-2 pr-0">
                  <ul class="nav nav-pills card-header-pills justify-content-end w-100">

       
                    <li class="nav-item">
                        <a class="btn btn-primary mr-1" href="#" @click="saveTemplate" title="Save"><i class="fa fa-save"></i></a>
                    </li>
                    
                  </ul>
                </div>

            </div>
            <div class="card-body">
                
                    <div class="row">
                        
                        <div class="col">


                        <b-tabs content-class="mt-3">
                            <b-tab title="Layout Editor" active>


<editor
       api-key="obip02r8no4uqkvy6x0salyqznd0lmjfq2oea5ro2symfsuc"
       :init="{
         height: 'calc(100vh - 300px)',
         menubar: false,

         plugins: [
         'fullpage',
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar: [
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help | code ',
           'shortcodeMenuContact | mergeTagsMenu | otherTagsMenu'
           ],

          setup: function (editor) {
            var toggleState = false;
        

            /* Contact Shortcode Menu Start */
            
            editor.ui.registry.addMenuButton('shortcodeMenuContact', {
              text: 'Contact Replacements',
              fetch: function (callback) {
                var items = [
                  {
                    type: 'menuitem',
                    text: 'First Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts first name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[firstname fallback=&quot;'+data.fallback+'&quot;]');
                                    editor.windowManager.close();
                                },
                            });

                        },
                        onAction: function(){ editor.insertContent('[firstname]'); editor.windowManager.close(); },
                        });
                    }

                  },{
                    type: 'menuitem',
                    text: 'Last Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts last name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[lastname fallback=&quot;'+data.fallback+'&quot;]');
                                    editor.windowManager.close();
                                },
                            });



                        },
                        onAction: function(){ editor.insertContent('[lastname]'); editor.windowManager.close(); },
                        });
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts company name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[company fallback=&quot;'+data.fallback+'&quot;]');
                                    editor.windowManager.close();
                                },
                            });



                        },
                        onAction: function(){ editor.insertContent('[company]'); editor.windowManager.close(); },
                        });
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email (linked)',
                    onAction: function () {
                      editor.insertContent('[email]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email (not-linked)',
                    onAction: function () {
                      editor.insertContent('[emailaddress]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Phone Number',
                    onAction: function () {
                      editor.insertContent('[telephone]');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Contact Shortcode Menu End */

            /* Merge Tags Menu Start */
            
            editor.ui.registry.addMenuButton('mergeTagsMenu', {
              text: 'Merge Tags',
              fetch: function (callback) {
                var items = [
                {
                    type: 'menuitem',
                    text: 'Email Subject',
                    onAction: function () {
                      editor.insertContent('*|SUBJECT|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Preheader',
                    onAction: function () {
                      editor.insertContent('*|PREHEADER|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Message',
                    onAction: function () {
                      editor.insertContent('*|BODY|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Button Text',
                    onAction: function () {
                      editor.insertContent('*|BUTTON|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Footer',
                    onAction: function () {
                      editor.insertContent('*|BODY|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 1',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_1|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 2',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_2|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 3',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_3|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 4',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_4|*');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Merge Tags Menu End */

         /* Other Tags Menu Start */
            
            editor.ui.registry.addMenuButton('otherTagsMenu', {
              text: 'Other Tags',
              fetch: function (callback) {
                var items = [
                  {
                    type: 'menuitem',
                    text: 'Unsubscribe (Linked Text)',
                    onAction: function () {
                      editor.insertContent('[unsubscribe]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Unsubscribe (URL)',
                    onAction: function () {
                      editor.insertContent('[unsubscribe_url]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Logo',
                    onAction: function () {
                      editor.insertContent('{email_logo}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Logo (Linked)',
                    onAction: function () {
                      editor.insertContent('{email_linked_logo}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Colour',
                    onAction: function () {
                      editor.insertContent('{accent}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Link to SizzleDeck',
                    onAction: function () {
                      editor.insertContent('{link}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender First Name',
                    onAction: function () {
                      editor.insertContent('{first_name}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Last Name',
                    onAction: function () {
                      editor.insertContent('{last_name}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Position',
                    onAction: function () {
                      editor.insertContent('{position}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Company Name',
                    onAction: function () {
                      editor.insertContent('{company_name}');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Other Tags Menu End */


           }

       }"

       v-model="layout"
     />

                            <!--<email-builder v-model="layout"></email-builder> -->
                        

                            </b-tab>
                            <b-tab title="Defaults & Merge Tags">
                                <p>Email templates can use the following merge tags, the defaults for which can be defined below:</p>

                            <form ref="emailpreviewform" action="/email/builder-preview" method="POST" target="builderPreview">
                                <input type="hidden" name="layout" :value="layout"/>
                                <input type="hidden" name="preview_type" :value="previewType"/>
                                <input type="hidden" name="_token" :value="csrf">

                                <b-form-group class="mx-auto" label="Email Subject *|SUBJECT|*">
                                  <b-input name="default_subject" type="text" v-model="mergeTags.subject"></b-input>
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Email Preheader *|PREHEADER|*">
                                  <b-input name="default_preheader" type="text" v-model="mergeTags.preheader"></b-input>
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Email Message *|BODY|*">
                                  <tiptap v-model="mergeTags.body"></tiptap>
                                  <input name="default_body" type="hidden" v-model="mergeTags.body"></input>
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Button Text *|BUTTON|*">
                                  <b-input name="default_button" class="w-2" type="text" v-model="mergeTags.button"></b-input>
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Email Footer *|FOOTER|*">
                                  <tiptap v-model="mergeTags.footer"></tiptap>
                                  <input name="default_footer" type="hidden" v-model="mergeTags.footer"></input>                
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Custom Field 1 *|CUSTOM_1|*">
                                  <tiptap v-model="mergeTags.custom_1"></tiptap>
                                  <input name="default_custom_1" type="hidden" v-model="mergeTags.custom_1"></input>                
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Custom Field 2 *|CUSTOM_2|*">
                                  <tiptap v-model="mergeTags.custom_2"></tiptap>
                                  <input name="default_custom_2" type="hidden" v-model="mergeTags.custom_2"></input>                
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Custom Field 3 *|CUSTOM_3|*">
                                  <tiptap v-model="mergeTags.custom_3"></tiptap>
                                  <input name="default_custom_3" type="hidden" v-model="mergeTags.custom_3"></input>                
                                </b-form-group>

                                <b-form-group class="mx-auto" label="Custom Field 4 *|CUSTOM_4|*">
                                  <tiptap v-model="mergeTags.custom_4"></tiptap>
                                  <input name="default_custom_4" type="hidden" v-model="mergeTags.custom_4"></input>                
                                </b-form-group>

                            </form>

                            </b-tab>
                        </b-tabs>

                        </div>
                        <div class="col">
                            <b-select v-model="previewType" :options="[{value:'dummy-contact',text:'Preview using dummy contact info'},{value:'no-contact',text:'Preview using fallbacks'}]"></b-select>
                            <iframe id="builderPreview" name="builderPreview" class="mt-1 w-100 border rounded" style="min-height: calc(100vh - 300px);"></iframe>
                            <small class="text-muted">Please note: An unsubscribe link MUST be included on all emails. If one is not included in your template, one will be added automatically.</small>
                        </div>

                    </div>

            </div>
        </div>


    <b-modal id="emailTemplateName" title="Edit Template Name" @ok="setName">
        <b-input v-model="tempTemplateName"></b-input>
    </b-modal>

    <b-modal ref="modalStart" id="modalStart" size="lg" :hide-footer="true" :hide-header="true" no-close-on-esc no-close-on-backdrop hide-header-close>

        <h5>Start from Scratch:</h5>

        <b-input-group prepend="Email Template Name">
            <b-form-input v-model="tempTemplateName" @keyup.enter="setNameStart"></b-form-input>
            <b-input-group-append>
                <b-button variant="primary" @click="setNameStart">OK</b-button>
            </b-input-group-append>
        </b-input-group>


        
        <div class="row mt-3 mb-2">
            <div class="col"><hr></div>
            <div class="col-auto col-auto pt-1 text-muted">OR</div>
            <div class="col"><hr></div>
        </div>

        
        <h5>Import Email Template from Library:</h5>


        <b-input-group>
            <b-form-select v-model="templateToImport" :options="availableTemplates"></b-form-select>
            <b-input-group-append>
                <b-button variant="primary" @click="importTemplate">Import</b-button>
            </b-input-group-append>
        </b-input-group>

    </b-modal>


    </div>

</template>
<script>

import Editor from '@tinymce/tinymce-vue';
import Noty from 'noty';


    export default {
        components: {
            'editor': Editor,
        },
        mounted() {
            this.loadAvailableTemplates();
            this.loadTemplate();

            if(!this.templateId){
                this.$refs['modalStart'].show();
            }
        },

        props: [
            'id'
        ],
        data: function(){
            return { 
                templateId: this.id,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                layout: null,
                templateName: 'Untitled',
                tempTemplateName: 'Untitled',
                availableTemplates: null,
                templateToImport: null,
                mergeTags:{
                    subject: '',
                    preheader: '',
                    body: '',
                    button: '',
                    footer: '',
                    custom_1: '',
                    custom_2: '',
                    custom_3: '',
                    custom_4: '',
                    preview: '',
                },
                previewType: 'dummy-contact',
            }
        },
        methods: {
            updateEmailPreview: function(){
                var vm = this;
                if(vm.$refs.emailpreviewform !== undefined){
                        vm.$nextTick(function () {
                            vm.$refs.emailpreviewform.submit();
                            vm.email_inital_load = true;
                        });
                }
            },
            editName: function(){
                var vm = this;
                vm.tempTemplateName = vm.templateName;
                vm.$bvModal.show('emailTemplateName');
            },
            setName: function(){
                var vm = this;
                vm.templateName = vm.tempTemplateName;
            },
            setNameStart: function(){
                var vm = this;
                vm.templateToImport = null;
                vm.templateName = vm.tempTemplateName;
                vm.$bvModal.hide('modalStart');
            },
            importTemplate: function(){
                var vm = this;
                vm.templateName = vm.templateName + ' (copy)';
                vm.$bvModal.hide('modalStart');
            },
            loadTemplateStart: function(){
                var vm = this;
                vm.$bvModal.hide('modalStart');
                vm.loadTemplate();
            },
            loadAvailableTemplates: function(){
                var vm = this;
                const url = `/email/templates/list-all`;
                axios.get(url).then(response => {

                    vm.availableTemplates = response.data.rows.map(({ id, name }) => ({ 'value':id, 'text':name }));
                    vm.availableTemplates.unshift({'value':null,'text':'Please choose a template to import...'});

                }).catch( error => {

                  if(error.response.status == '419'){

                    new Noty({
                            text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                            type: 'error',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: false
                        }).show()

                  }else{

                  new Noty({
                            text: 'There has been an error. Please refresh this page.',
                            type: 'error',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: false
                        }).show();

                  }                  

                });

            },
            loadTemplate: function(){
               var vm = this;
               
               if(vm.templateId){

               const url = `/email/get/`+vm.templateId;
               axios.get(url).then(response => {
                
                vm.templateName = response.data.name;
                vm.layout = response.data.layout;
                

                vm.mergeTags.layout = response.data.layout;
                vm.mergeTags.body = response.data.body;
                vm.mergeTags.preheader = response.data.preheader;
                vm.mergeTags.subject = response.data.subject;
                vm.mergeTags.button = response.data.button;
                vm.mergeTags.footer = response.data.footer;
                vm.mergeTags.custom_1 = response.data.custom_1;
                vm.mergeTags.custom_2 = response.data.custom_2;
                vm.mergeTags.custom_3 = response.data.custom_3;
                vm.mergeTags.custom_4 = response.data.custom_4;             


                vm.updateEmailPreview();

                }).catch( error => {

                  if(error.response.status == '419'){

                    new Noty({
                            text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                            type: 'error',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: false
                        }).show()

                  }else{

                  new Noty({
                            text: 'There has been an error. Please refresh this page.',
                            type: 'error',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: false
                        }).show();

                  }

                  

                });

              }else{
                vm.layout = `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width" initial-scale="1">
    <!--[if !mso]>
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <![endif]-->
    <meta name="x-apple-disable-message-reformatting">
    <title></title>
    <!--[if mso]>
        <style>
            * { font-family: sans-serif !important; }
        </style>
    <![endif]-->
    <!--[if !mso]><!-->
        <!-- Insert font reference, e.g. <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700" rel="stylesheet"> -->
    <!--<![endif]-->
    <style>
        *,
        *:after,
        *:before {
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        }
        * {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }
        html,
        body,
        .document {
            width: 100% !important;
            height: 100% !important;
            margin: 0;
            padding: 0;
        }
        body {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-rendering: optimizeLegibility;
        }
        div[style*="margin: 16px 0"] {
            margin: 0 !important;
        }
        table,
        td {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
        }
        table {
            border-spacing: 0;
            border-collapse: collapse;
            table-layout: fixed;
            margin: 0 auto;
        }
        img {
            -ms-interpolation-mode: bicubic;
            max-width: 100%;
            border: 0;
        }
        *[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
        }
        .x-gmail-data-detectors,
        .x-gmail-data-detectors *,
        .aBn {
            border-bottom: 0 !important;
            cursor: default !important;
        }
        .btn {
            -webkit-transition: all 200ms ease;
            transition: all 200ms ease;
        }
        .btn:hover {
            background-color: dodgerblue;
        }
        @media screen and (max-width: 750px) {
            .container {
                width: 100%;
                margin: auto;
            }
            .stack {
                display: block;
                width: 100%;
                max-width: 100%;
            }
        }
    </style>
</head>
<body>
    <div style="display: none; max-height: 0px; overflow: hidden;">
        *|PREHEADER|*
    </div>
    <div style="display: none; max-height: 0px; overflow: hidden;">&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;</div>
    <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" class="document">
        <tr>
            <td valign="top">
                <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" width="100%" class="container">
                    <tr>
                        <td>
                            <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" width="100%" >
                                <tr>
                                    <td>
                                        <p></p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
              }
            },
            saveTemplate: function(){

                var vm = this;
                const url = `/email/save`;

              axios.post(url,{
                'emailTemplate':vm.templateId,
                'emailTemplateName':vm.templateName,
                'emailTemplateLayout':vm.layout,

                'emailTemplateSubject':vm.mergeTags.subject,
                'emailTemplatePreheader':vm.mergeTags.preheader,
                'emailTemplateBody':vm.mergeTags.body,
                'emailTemplateFooter':vm.mergeTags.footer,
                'emailTemplateButton':vm.mergeTags.button,
                'emailTemplateCustom1':vm.mergeTags.custom_1,
                'emailTemplateCustom2':vm.mergeTags.custom_2,
                'emailTemplateCustom3':vm.mergeTags.custom_3,
                'emailTemplateCustom4':vm.mergeTags.custom_4,

              }).then(response => {

                if(!response.data.status){
                    new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 2000
                      }).show();

                }else{

                    new Noty({
                          text: response.data.message,
                          type: response.data.status,
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 1000
                      }).show();

                    if(response.data.status == 'success'){
                      if(!vm.templateId){window.history.pushState("", "", "/email/edit/"+response.data.emailTemplate);}
                      vm.templateId = response.data.emailTemplate;
                      
                    }

                }
                
              }).catch( error => {

                if(error.response.status == '419'){

                  new Noty({
                          text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show()

                }else{

                new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show();

                }

                

              });

            }
        },
        watch:{
            layout: function(){
                this.updateEmailPreview();
            },
            previewType: function(){
                this.updateEmailPreview();
            },
            templateToImport: function(){
                this.templateId = this.templateToImport;
                this.loadTemplate();
                this.templateId = null;
            },
            mergeTags:{
                handler(newValue, oldValue) {
                    this.updateEmailPreview();
                },
                deep: true
            },
        }
    }
</script>
<style type="text/css">

</style>
